import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step, introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-student', {
  key: 'admin-student',
  label: 'Students',
  getSteps: () => [
    introStep({
      title: 'Manage Students',
      content:
        'This is your student hub. Use the tabs to admit a new student, browse and edit existing ones, bulk-import from a spreadsheet, or promote everyone at the end of a session.',
    }),
    step({
      target: '#tour-students-admit-form',
      title: 'Admit a New Student',
      content:
        'Fill out the form to add a single student — basic details, classroom assignment, and (for tertiary) programme and level. Required fields are marked with an asterisk.',
      placement: 'top',
    }),
    step({
      target: '#tour-students-filters',
      title: 'Find Students',
      content:
        'Filter by session, classroom, or (for tertiary) programme and campus. Or use search to look up a student by name or ID. Switch to the "Student Overview" tab to see this view.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-students-table',
      title: 'Student List',
      content:
        'Each row is a student. Use the action buttons on the right to view their full profile, edit their details, or remove them from the school.',
      placement: 'top',
    }),
  ],
});
